import { z } from 'my-zod'
import { customersModel } from '../../customer-operations/customer'
import { customerSubscriptionSystemView } from '../customer-subscription'

export const subscriberAdminView = customersModel.augment({
  planName: customerSubscriptionSystemView.shape.planName.setLabel('Subscription Plan Name'),
  billingServiceSubscriptionId: customerSubscriptionSystemView.shape.id,
  subscriptionStatus: customerSubscriptionSystemView.shape.status,
  activationDate: customerSubscriptionSystemView.shape.activationDate,
  cancellationDate: customerSubscriptionSystemView.shape.cancellationDate.setLabel('Subscription Cancellation Date'),
  creditBalance: z.number()
})

export type subscriberAdminView = z.infer<typeof subscriberAdminView>
